import { useEffect, useState } from 'react';
import type { FC } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import type { NavNode } from '../../data/navigation';
import { ChevronDownIcon } from '../../assets/icons/icons';
import styles from './Sidebar.module.scss';
import React from 'react';

interface NavGroupProps {
    node: NavNode;
}

/** Содержит ли ветка маршрут, на котором мы сейчас находимся. */
const containsPath = (node: NavNode, pathname: string): boolean => {
    if (node.to && node.to !== '/' && pathname.startsWith(node.to)) return true;

    return (node.children ?? []).some((child) => containsPath(child, pathname));
};

export const NavGroup: FC<NavGroupProps> = ({ node }) => {
    const { pathname } = useLocation();
    const [open, setOpen] = useState(() => containsPath(node, pathname));

    const Icon = node.icon;

    // при переходе внутрь ветки она раскрывается сама
    useEffect(() => {
        if (containsPath(node, pathname)) setOpen(true);
    }, [node, pathname]);

    if (!node.children) {
        return (
            <NavLink
                to={node.to ?? '#'}
                end={node.exact}
                className={({ isActive }) =>
                    `${styles.navItem} ${isActive ? styles.navItemActive : ''}`
                }
            >
                {Icon && (
                    <span className={styles.navIcon}>
                        <Icon />
                    </span>
                )}
                {node.label}
            </NavLink>
        );
    }

    return (
        <div className={`${styles.group} ${open ? styles.groupOpen : ''}`}>
            <button
                type="button"
                className={styles.navItem}
                aria-expanded={open}
                onClick={() => setOpen((value) => !value)}
            >
                {Icon && (
                    <span className={styles.navIcon}>
                        <Icon />
                    </span>
                )}
                {node.label}
                <span className={styles.navArrow} aria-hidden="true">
                    <ChevronDownIcon />
                </span>
            </button>

            {open && (
                <div className={styles.subnav}>
                    {node.children.map((child) => (
                        <NavGroup key={child.id} node={child} />
                    ))}
                </div>
            )}
        </div>
    );
};